import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * BackButton — universal in-app back navigation.
 *
 * Uses browser history via ``navigate(-1)``. Hidden on portal root pages
 * where "back" has no meaningful destination (from ``/insurer``,
 * ``/broker`` or ``/master`` the previous entry is typically the login
 * screen, which we never want to jump to accidentally).
 */
export const BackButton: React.FC<{ className?: string }> = ({ className }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const path = location.pathname.replace(/\/+$/, '');
  const roots = ['/insurer', '/broker', '/master', ''];
  if (roots.includes(path)) return null;

  return (
    <Button
      size="sm"
      variant="ghost"
      onClick={() => navigate(-1)}
      className={`gap-1 -ml-1 text-raptor-navy/70 hover:text-raptor-navy ${className ?? ''}`}
      data-testid="back-button"
      aria-label="Go back"
      title="Go back"
    >
      <ArrowLeft size={16} /> Back
    </Button>
  );
};
